import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faPen as faPenSolid,
    faPlus as faPlusSolid,
    faChevronLeft,
    faChevronRight,
    faAnglesLeft,
    faAnglesRight,
    faChevronDown,
    faChevronUp,
    faRepeat,
    faCalendar,
    faSackDollar,
    faCheck,
    faBriefcase,
    faCalendarDays,
    faClock,
    faFlagCheckered,
    faLandmarkFlag,
    faEye,
} from "@fortawesome/free-solid-svg-icons";
import "../../../assets/scss/components/_calendar.scss";
import { Popup, ScrollView } from "devextreme-react";
import QuickAddShiftForm from "../QuickAddShift/QuickAddShiftForm";
import sharedUtils from "../grid/sharedUtilities";
import AddEditPopUpService from "../../services/AddEditPopUpService";
import { AxiosResponse } from "axios";
import ShiftMatrixGrid from "../ShiftMatrix/ShiftMatrixGrid";
interface Props {
    initialStart: string;
    providerId: string;
    serviceTypeId: string;
    applyButtonClicked: boolean;
    setApplyButtonClicked: (value: boolean) => void;
    setDateFrom: (date: Date) => void;
    setArrowButtonClicked: (value: boolean) => void;
    resetData: boolean;
    setResetData: () => void;
}

interface State {
    currentStartDate: Date;
    currentEndDate: Date;
    expandedEventIds: number[];
    expandedGroupKeys: any[];
    events: any[];
    openNewShift: boolean;
    openEditShift: boolean;
    editShiftId: string;
    dateOfNewShift: Date | null;
    displayGroupedShifts: boolean;
    dateGroupBy: string;
    providerNameGroupBy: string;
    serviceTypeGroupBy: string;
    clientNameGroupBy: string;
}

const RANGE_DAYS = 35;

export default class ProviderCalendarGrid extends Component<Props, State> {
    serviceCategories = [
        { text: "Contract Cleaning", id: 1, color: "#40C4FF" },
        { text: "Entertainment", id: 2, color: "#7C4DFF" },
        { text: "Security", id: 3, color: "#E040FB" },
        { text: "Gardening", id: 4, color: "#00C853" },
        { text: "Maintenance", id: 5, color: "#FF8A65" },
        { text: "Miscellaneous", id: 6, color: "#FF6D00" },
        { text: "Window Cleaning", id: 7, color: "#2962FF" },
    ];

    editViewService: AddEditPopUpService;
    utils: sharedUtils;
    constructor(props: Props) {
        super(props);

        const initialStartDate = this.parseDateString(props.initialStart);
        const initialEndDate = new Date(initialStartDate);
        initialEndDate.setDate(initialStartDate.getDate() + (RANGE_DAYS - 1));
        this.editViewService = new AddEditPopUpService();
        this.utils = new sharedUtils();
        this.state = {
            currentStartDate: initialStartDate,
            currentEndDate: initialEndDate,
            expandedEventIds: [],
            expandedGroupKeys: [],
            events: [],
            openNewShift: false,
            openEditShift: false,
            editShiftId: "",
            dateOfNewShift: null,
            displayGroupedShifts: false,
            dateGroupBy: "",
            providerNameGroupBy: "",
            serviceTypeGroupBy: "",
            clientNameGroupBy: "",
        };
    }

    parseDateString = (dateStr: string): Date => {
        const [day, month, year] = dateStr.split("/").map(Number);
        return new Date(year, month - 1, day);
    };

    componentDidUpdate(prevProps: Props) {
        if (
            prevProps.applyButtonClicked != this.props.applyButtonClicked &&
            this.props.applyButtonClicked &&
            this.props.initialStart
        ) {
            const start = this.parseDateString(this.props.initialStart);
            const end = new Date(start);
            end.setDate(start.getDate() + (RANGE_DAYS - 1));

            this.setState(
                {
                    currentStartDate: start,
                    currentEndDate: end,
                    expandedEventIds: [],
                },
                () => {
                    this.calendarGridData(
                        this.props.providerId,
                        this.props.serviceTypeId,
                        this.utils.convertDateToString(start),
                        this.utils.convertDateToString(end)
                    );
                }
            );
        }
        if (this.props.resetData) {
            this.setState({
                expandedEventIds: [],
                expandedGroupKeys: [],
                events: [],
            });
            this.props.setResetData();
        }
    }

    calendarGridData = (providerId: string, serviceId: string, dateFrom: string, dateTo: string) => {
        let params = `providerId=${providerId}&serviceId=${serviceId}&dateFrom=${dateFrom}&dateTo=${dateTo}`;
        this.editViewService
            .grtVenueProviderCalendarGridDetails(params)
            .then(this.handleSuccessCalendarGridData)
            .catch(this.handleStandardError);
    };
    handleSuccessCalendarGridData = (res: AxiosResponse<any>) => {
        this.props.setApplyButtonClicked(false);
        this.setState({
            events: res?.data?.data?.billableItemCalenderResponseDTO
                ? res?.data?.data?.billableItemCalenderResponseDTO
                : [],
        });
    };

    handleStandardError = (error: any) => {
        this.props.setApplyButtonClicked(false);
        var respMessage: string = JSON.stringify(error);
        console.error(respMessage);
    };

    getDaysInRange = (): string[] => {
        const { currentStartDate, currentEndDate } = this.state;

        const days: string[] = [];
        const date = new Date(currentStartDate);

        while (date <= currentEndDate) {
            days.push(this.formatDate(date));
            date.setDate(date.getDate() + 1);
        }

        return days;
    };

    groupByClient = (events: any[]) => {
        const map: Record<string, any[]> = {};

        events.forEach((e) => {
            if (!map[e.client]) {
                map[e.client] = [];
            }
            map[e.client].push(e);
        });

        return Object.keys(map).map((client) => {
            const clientEvents = map[client];
            return {
                client,
                provider: clientEvents[0].provider,
                serviceTypeValue: clientEvents[0].serviceTypeValue,
                count: clientEvents.length,
                totalCost: clientEvents.reduce((sum, e) => sum + Number(e.providerPayAmountLocal || 0), 0),
                dateFrom: clientEvents[0].dateFrom,
                venue: clientEvents[0].venue,
            };
        });
    };

    formatDate = (date: Date): string => {
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();

        return `${day}/${month}/${year}`;
    };

    handleEventToggle = (eventId: number, e: React.MouseEvent) => {
        e.stopPropagation();
        this.setState((prev) => ({
            expandedEventIds: prev.expandedEventIds.includes(eventId)
                ? prev.expandedEventIds.filter((id) => id !== eventId)
                : [...prev.expandedEventIds, eventId],
        }));
    };

    handleGroupToggle = (groupKey: string, e: any) => {
        e.stopPropagation();
        this.setState((prevState: any) => ({
            expandedGroupKeys: prevState.expandedGroupKeys.includes(groupKey)
                ? prevState.expandedGroupKeys.filter((k: string) => k !== groupKey)
                : [...prevState.expandedGroupKeys, groupKey],
        }));
    };

    handlePrevMonth = () => {
        let startate = this.state.currentStartDate;
        startate.setDate(startate.getDate() - RANGE_DAYS);
        this.props.setDateFrom(startate);
        this.props.setArrowButtonClicked(true);
    };

    handleNextMonth = () => {
        let startate = this.state.currentStartDate;
        startate.setDate(startate.getDate() + RANGE_DAYS);
        this.props.setDateFrom(startate);
        this.props.setArrowButtonClicked(true);
    };

    handlePrevWeek = () => {
        let startate = this.state.currentStartDate;
        startate.setDate(startate.getDate() - 7);
        this.props.setDateFrom(startate);
        this.props.setArrowButtonClicked(true);
    };

    handleNextWeek = () => {
        let startate = this.state.currentStartDate;
        startate.setDate(startate.getDate() + 7);
        this.props.setDateFrom(startate);
        this.props.setArrowButtonClicked(true);
    };
    hideAndRefresh = () => {
        this.setState({
            openNewShift: false,
            dateOfNewShift: null,
            editShiftId: "",
            openEditShift: false,
        });
        this.props.setApplyButtonClicked(true);
    };
    formatPoundAmount = (value: number) =>
        `${value < 0 ? "-" : ""}£${new Intl.NumberFormat("en-GB", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }).format(Math.abs(value))}`;

    render() {
        const {
            currentStartDate,
            currentEndDate,
            expandedEventIds,
            expandedGroupKeys,
            events,
            openEditShift,
            openNewShift,
            displayGroupedShifts,
        } = this.state;
        const days = this.getDaysInRange();

        const location = {
            state: {
                id: 0,
                serviceTypeId: "10",
                pointOfNavigation: "manageshifts",
                filterStartDate: "",
                filterEndDate: "",
            },
        };

        return (
            <>
                <div className="venue-calendar-container">
                    <div className="calendar-header">
                        <button className="header-button">
                            <FontAwesomeIcon icon={faAnglesLeft} onClick={this.handlePrevMonth} />
                        </button>
                        <button className="header-button">
                            <FontAwesomeIcon icon={faChevronLeft} onClick={this.handlePrevWeek} />
                        </button>
                        <div className="header-range">
                            {currentStartDate
                                ? currentStartDate.toLocaleDateString("en-GB", {
                                      day: "2-digit",
                                      month: "short",
                                      year: "numeric",
                                  })
                                : ""}{" "}
                            -{" "}
                            {currentEndDate
                                ? currentEndDate.toLocaleDateString("en-GB", {
                                      day: "2-digit",
                                      month: "short",
                                      year: "numeric",
                                  })
                                : ""}
                        </div>
                        <button className="header-button">
                            <FontAwesomeIcon icon={faChevronRight} onClick={this.handleNextWeek} />
                        </button>
                        <button className="header-button">
                            <FontAwesomeIcon icon={faAnglesRight} onClick={this.handleNextMonth} />
                        </button>
                    </div>

                    <div className="calendar-grid">
                        {days.map((day, idx) => {
                            const dayEvents = events.filter((e) => e.dateFrom === day);
                            const shouldGroup = dayEvents.length > 5;
                            const groupedEvents = shouldGroup ? this.groupByClient(dayEvents) : [];
                            return (
                                <div key={idx} className="day-cell">
                                    <div className="day-header">
                                        {day.split("/")[0]}{" "}
                                        <span>
                                            {new Date(day.split("/").reverse().join("-")).toLocaleString("default", {
                                                weekday: "short",
                                            })}
                                        </span>
                                    </div>

                                    <div className="events-container">
                                        {shouldGroup ? (
                                            <>
                                                {groupedEvents.map((ev) => {
                                                    const groupKey = `${day}-${ev.client}`;
                                                    const isGroupExpanded = expandedGroupKeys.includes(groupKey);

                                                    return (
                                                        <div
                                                            key={groupKey}
                                                            className={`event-card ${
                                                                isGroupExpanded ? "expanded" : ""
                                                            }`}
                                                            style={{
                                                                border: `1px solid ${
                                                                    this.serviceCategories.find(
                                                                        (s) => s.text === ev.serviceTypeValue
                                                                    )?.color
                                                                }`,
                                                            }}
                                                        >
                                                            <div
                                                                className="event-card-header"
                                                                style={{
                                                                    backgroundColor: this.serviceCategories.find(
                                                                        (s) => s.text === ev.serviceTypeValue
                                                                    )?.color,
                                                                }}
                                                            >
                                                                <div className="event-name event-name-header">
                                                                    <div className="event-details-value">
                                                                        {ev.client}
                                                                    </div>
                                                                </div>

                                                                <div className="event-actions">
                                                                    <FontAwesomeIcon
                                                                        icon={
                                                                            isGroupExpanded
                                                                                ? faChevronUp
                                                                                : faChevronDown
                                                                        }
                                                                        className="event-action-icon"
                                                                        onClick={(e) =>
                                                                            this.handleGroupToggle(groupKey, e)
                                                                        }
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="event-card-body">
                                                                <div className="event-main-group">
                                                                    <div className="event-details-group">
                                                                        <div className="event-details-field">
                                                                            <div
                                                                                className="event-icon"
                                                                                style={{
                                                                                    color: this.serviceCategories.filter(
                                                                                        (s) =>
                                                                                            s.text ===
                                                                                            ev.serviceTypeValue
                                                                                    )[0].color,
                                                                                }}
                                                                            >
                                                                                <FontAwesomeIcon
                                                                                    icon={faLandmarkFlag}
                                                                                />
                                                                            </div>
                                                                            <div className="event-details-value">
                                                                                {`Total Count: ${ev.count}`}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="event-price">
                                                                        <div
                                                                            className="event-icon"
                                                                            style={{
                                                                                color: this.serviceCategories.filter(
                                                                                    (s) =>
                                                                                        s.text === ev.serviceTypeValue
                                                                                )[0].color,
                                                                            }}
                                                                        >
                                                                            <FontAwesomeIcon icon={faSackDollar} />
                                                                        </div>
                                                                        <div className="event-details-value">
                                                                            {this.formatPoundAmount(ev.totalCost)}
                                                                        </div>
                                                                    </div>

                                                                    {isGroupExpanded && (
                                                                        <>
                                                                            <div className="event-name">
                                                                                <div
                                                                                    className="event-icon"
                                                                                    style={{
                                                                                        color: this.serviceCategories.filter(
                                                                                            (s) =>
                                                                                                s.text ===
                                                                                                ev.serviceTypeValue
                                                                                        )[0].color,
                                                                                    }}
                                                                                >
                                                                                    <FontAwesomeIcon icon={faCheck} />
                                                                                </div>
                                                                                <div className="event-details-value">
                                                                                    {ev.serviceTypeValue}
                                                                                </div>
                                                                            </div>

                                                                            <div className="event-details-field">
                                                                                <div
                                                                                    className="event-icon"
                                                                                    style={{
                                                                                        color: this.serviceCategories.filter(
                                                                                            (s) =>
                                                                                                s.text ===
                                                                                                ev.serviceTypeValue
                                                                                        )[0].color,
                                                                                    }}
                                                                                >
                                                                                    <FontAwesomeIcon
                                                                                        icon={faCalendarDays}
                                                                                    />
                                                                                </div>
                                                                                <div className="event-details-value">
                                                                                    {ev.dateFrom}
                                                                                </div>
                                                                            </div>
                                                                        </>
                                                                    )}
                                                                </div>
                                                                {isGroupExpanded && (
                                                                    <div
                                                                        className="view-shifts"
                                                                        onClick={() =>
                                                                            this.setState({
                                                                                displayGroupedShifts: true,
                                                                                dateGroupBy: day,
                                                                                providerNameGroupBy: ev.provider,
                                                                                serviceTypeGroupBy: ev.serviceTypeValue,
                                                                                clientNameGroupBy: ev.client,
                                                                            })
                                                                        }
                                                                        style={{
                                                                            color: this.serviceCategories.find(
                                                                                (s) => s.text === ev.serviceTypeValue
                                                                            )?.color,
                                                                        }}
                                                                    >
                                                                        <FontAwesomeIcon icon={faEye} /> VIEW SHIFTS
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    );
                                                })}
                                            </>
                                        ) : (
                                            <>
                                                {dayEvents.map((ev) => {
                                                    const isExpanded = expandedEventIds.includes(ev.billableItemId);
                                                    return (
                                                        <div
                                                            key={ev.billableItemId}
                                                            className={`event-card ${isExpanded ? "expanded" : ""}`}
                                                            style={{
                                                                border: `1px solid ${
                                                                    this.serviceCategories.filter(
                                                                        (s) => s.text === ev.serviceTypeValue
                                                                    )[0].color
                                                                }`,
                                                            }}
                                                        >
                                                            <div
                                                                className="event-card-header"
                                                                style={{
                                                                    backgroundColor: this.serviceCategories.filter(
                                                                        (s) => s.text === ev.serviceTypeValue
                                                                    )[0].color,
                                                                }}
                                                            >
                                                                <div className="event-name event-name-header">
                                                                    <div className="event-details-value">
                                                                        {ev.venue?.split("-")[1].trim()}
                                                                    </div>
                                                                </div>
                                                                <div className="event-actions">
                                                                    {ev.reoccurance === "Yes" ? (
                                                                        <FontAwesomeIcon
                                                                            icon={faRepeat}
                                                                            className="event-action-icon"
                                                                        />
                                                                    ) : null}
                                                                    {ev.multipleDates === "Yes" ? (
                                                                        <FontAwesomeIcon
                                                                            icon={faCalendar}
                                                                            className="event-action-icon"
                                                                        />
                                                                    ) : null}
                                                                    <FontAwesomeIcon
                                                                        icon={isExpanded ? faChevronUp : faChevronDown}
                                                                        className="event-action-icon"
                                                                        onClick={(e) =>
                                                                            this.handleEventToggle(ev.billableItemId, e)
                                                                        }
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="event-card-body">
                                                                <div className="event-main">
                                                                    <div className="event-name">
                                                                        <div
                                                                            className="event-icon"
                                                                            style={{
                                                                                color: this.serviceCategories.filter(
                                                                                    (s) =>
                                                                                        s.text === ev.serviceTypeValue
                                                                                )[0].color,
                                                                            }}
                                                                        >
                                                                            <FontAwesomeIcon icon={faCheck} />
                                                                        </div>
                                                                        <div className="event-details-value">
                                                                            {ev.serviceSubTypeValue}
                                                                        </div>
                                                                    </div>
                                                                    <div className="event-price">
                                                                        <div
                                                                            className="event-icon"
                                                                            style={{
                                                                                color: this.serviceCategories.filter(
                                                                                    (s) =>
                                                                                        s.text === ev.serviceTypeValue
                                                                                )[0].color,
                                                                            }}
                                                                        >
                                                                            <FontAwesomeIcon icon={faSackDollar} />
                                                                        </div>
                                                                        <div className="event-details-value">
                                                                            {this.formatPoundAmount(
                                                                                ev.providerPayAmountLocal
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                {isExpanded && (
                                                                    <>
                                                                        <div className="event-details">
                                                                            <div className="event-details-field">
                                                                                <div
                                                                                    className="event-icon"
                                                                                    style={{
                                                                                        color: this.serviceCategories.filter(
                                                                                            (s) =>
                                                                                                s.text ===
                                                                                                ev.serviceTypeValue
                                                                                        )[0].color,
                                                                                    }}
                                                                                >
                                                                                    <FontAwesomeIcon
                                                                                        icon={faBriefcase}
                                                                                    />
                                                                                </div>
                                                                                <div className="event-details-value">
                                                                                    {ev.serviceTypeValue}
                                                                                </div>
                                                                            </div>
                                                                            <div className="event-details-field">
                                                                                <div
                                                                                    className="event-icon"
                                                                                    style={{
                                                                                        color: this.serviceCategories.filter(
                                                                                            (s) =>
                                                                                                s.text ===
                                                                                                ev.serviceTypeValue
                                                                                        )[0].color,
                                                                                    }}
                                                                                >
                                                                                    <FontAwesomeIcon
                                                                                        icon={faCalendarDays}
                                                                                    />
                                                                                </div>
                                                                                <div className="event-details-value">
                                                                                    {ev.dateFrom === ev.dateTo
                                                                                        ? `${ev.dateFrom}`
                                                                                        : `${ev.dateFrom} - ${ev.dateTo}`}
                                                                                </div>
                                                                            </div>
                                                                            {ev.shift && (
                                                                                <div className="event-details-field">
                                                                                    <div
                                                                                        className="event-icon"
                                                                                        style={{
                                                                                            color: this.serviceCategories.filter(
                                                                                                (s) =>
                                                                                                    s.text ===
                                                                                                    ev.serviceTypeValue
                                                                                            )[0].color,
                                                                                        }}
                                                                                    >
                                                                                        <FontAwesomeIcon
                                                                                            icon={faClock}
                                                                                        />
                                                                                    </div>
                                                                                    <div className="event-details-value">
                                                                                        {ev.shift}
                                                                                    </div>
                                                                                </div>
                                                                            )}
                                                                            <div className="event-details-field">
                                                                                <div
                                                                                    className="event-icon"
                                                                                    style={{
                                                                                        color: this.serviceCategories.filter(
                                                                                            (s) =>
                                                                                                s.text ===
                                                                                                ev.serviceTypeValue
                                                                                        )[0].color,
                                                                                    }}
                                                                                >
                                                                                    <FontAwesomeIcon icon={faCheck} />
                                                                                </div>
                                                                                <div className="event-details-value">
                                                                                    {ev.client}
                                                                                </div>
                                                                            </div>
                                                                            <div className="event-details-field">
                                                                                <div
                                                                                    className="event-icon"
                                                                                    style={{
                                                                                        color: this.serviceCategories.filter(
                                                                                            (s) =>
                                                                                                s.text ===
                                                                                                ev.serviceTypeValue
                                                                                        )[0].color,
                                                                                    }}
                                                                                >
                                                                                    <FontAwesomeIcon
                                                                                        icon={faFlagCheckered}
                                                                                    />
                                                                                </div>
                                                                                <div className="event-details-value">
                                                                                    {ev.status}
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div
                                                                            className="event-edit"
                                                                            onClick={() =>
                                                                                this.setState({
                                                                                    openEditShift: true,
                                                                                    editShiftId: ev.billableItemId,
                                                                                })
                                                                            }
                                                                            style={{
                                                                                color: this.serviceCategories.filter(
                                                                                    (s) =>
                                                                                        s.text === ev.serviceTypeValue
                                                                                )[0].color,
                                                                            }}
                                                                        >
                                                                            <FontAwesomeIcon
                                                                                icon={faPenSolid}
                                                                                size="sm"
                                                                            />
                                                                        </div>
                                                                    </>
                                                                )}
                                                            </div>
                                                        </div>
                                                    );
                                                })}
                                            </>
                                        )}
                                    </div>

                                    <div className="add-row">
                                        <div
                                            className="add-icon"
                                            onClick={() =>
                                                this.setState({ dateOfNewShift: this.parseDateString(day) }, () => {
                                                    this.setState({
                                                        openNewShift: true,
                                                    });
                                                })
                                            }
                                        >
                                            <FontAwesomeIcon icon={faPlusSolid} />
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>

                {openEditShift && (
                    <Popup
                        visible={openEditShift}
                        onHiding={() => this.setState({ openEditShift: false, editShiftId: "" })}
                        showTitle
                        showCloseButton
                        title="Edit Shift"
                    >
                        <ScrollView width="100%" height="100%">
                            <QuickAddShiftForm
                                location={location}
                                history={undefined}
                                hidePopup={(v: boolean) => this.setState({ openEditShift: false, editShiftId: "" })}
                                navigateFrom={"providerCalendar"}
                                billableItemId={this.state.editShiftId}
                                hideAndRefresh={this.hideAndRefresh}
                            />
                        </ScrollView>
                    </Popup>
                )}

                {openNewShift && (
                    <Popup
                        visible={openNewShift}
                        onHiding={() => this.setState({ openNewShift: false, dateOfNewShift: null })}
                        showTitle
                        showCloseButton
                        title="Add Shift"
                    >
                        <ScrollView width="100%" height="100%">
                            <QuickAddShiftForm
                                location={location}
                                history={undefined}
                                hidePopup={(v: boolean) => this.setState({ openNewShift: v, dateOfNewShift: null })}
                                navigateFrom={"providerCalendar"}
                                date={this.state.dateOfNewShift}
                                serviceTypeId={this.props.serviceTypeId}
                                hideAndRefresh={this.hideAndRefresh}
                            />
                        </ScrollView>
                    </Popup>
                )}

                {displayGroupedShifts && (
                    <Popup
                        visible={displayGroupedShifts}
                        onHiding={() => this.setState({ displayGroupedShifts: false })}
                        showTitle
                        showCloseButton
                        title="View Shifts"
                    >
                        <ScrollView width="100%" height="100%">
                            <ShiftMatrixGrid
                                dateRangeFrom={this.state.dateGroupBy}
                                dateRangeTo={this.state.dateGroupBy}
                                filterText={""}
                                navigateFrom={"providerCalendar"}
                                providerName={this.state.providerNameGroupBy}
                                serviceType={this.state.serviceTypeGroupBy}
                                clientName={this.state.clientNameGroupBy}
                            />
                        </ScrollView>
                    </Popup>
                )}
            </>
        );
    }
}
